import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getCarImagesQueryOptions } from "./get-car-images";

import { api } from "@/lib/api-client";

import type { MutationConfig } from "@/lib/react-query";

export const deleteCarImage = async ({ carId, fileId }: { carId: string; fileId: string }) => {
  return api.delete(`/carburate/files/cars/images/${carId}/id/${fileId}/`);
};

type UseDeleteCarImageOptions = {
  mutationConfig?: MutationConfig<typeof deleteCarImage>;
};

export const useDeleteCarImage = ({ mutationConfig }: UseDeleteCarImageOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, { carId, ...args }, ...rest) => {
      queryClient.invalidateQueries({
        queryKey: getCarImagesQueryOptions(carId).queryKey,
      });
      onSuccess?.(data, { carId, ...args }, ...rest);
    },
    ...restConfig,
    mutationFn: deleteCarImage,
  });
};
